// @flow

import { RECEIVED_REVIEW } from './constants';
import type { ReceivedReview } from './actions';
import type { Review } from '../../types';

const initialState = {
  items: [],
  formLinkUrl: '',
  formLinkText: '',
};

export type State = Review;

export default (state: State = initialState, action: ReceivedReview) => {
  switch (action.type) {
    case RECEIVED_REVIEW:
      return {
        items: action.payload.items,
        formLinkUrl: action.payload.formLinkUrl,
        formLinkText: action.payload.formLinkText,
      };
    default:
      return state;
  }
};
